'use strict'

module.exports = (function () {
    /**
    * @ngdoc method
    * @name featureDetection
    * @description Use this to check on whether a particular JS feature is enabled in the current browser
    **/

    var isPassiveSupported = function (selector) {
        let isPassiveSupported = false;

        try {
            const options = {
                get passive() {
                    // This function will be called when the browser
                    // attempts to access the passive property.
                    isPassiveSupported = true;
                    return false;
                },
            };

            window.addEventListener("passive-support-text", null, options);
            window.removeEventListener("passive-support-text", null, options);
        } catch (err) {
            isPassiveSupported = false;
        }

        return isPassiveSupported;
    }

    // Return an object exposing the public items
    return {
        isPassiveSupported: isPassiveSupported
    };
}())